
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/proposal/[proposalId]/pre-payment",
      function () {
        return require("private-next-pages/account/proposal/[proposalId]/pre-payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/proposal/[proposalId]/pre-payment"])
      });
    }
  